import Close from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, fetchMedia } from '../../../../../Features/storefrontSlice';
import ImageBox from './ImageBox';
import { convertToWebP, getFileExtensionAndType } from '../../../../../lib/utils/utils';
import { uploadFileToPresignedURL } from '../../../../../lib/utils/apiCalls';
import imageCompression from 'browser-image-compression';
import { apiV1 } from '../../../../../Auth/Interceptor';

async function uploadMedia(image) {
    let { extension, fileType } = getFileExtensionAndType(image);

    if (fileType.includes("image") || extension === "gif") {
        image = await convertToWebP(image);
        extension = "webp";
        fileType = "image/webp";
    }

    try {
        const callBody = {
            contentType: fileType,
            ext: extension,
        };

        const response = await apiV1.post('media/upload', callBody);
        const { data: { data } } = response;
        const { preSignedUrl, file: fileName, keys } = data;

        await uploadFileToPresignedURL(image, preSignedUrl);

        const convertedUrl = fileName.replace(
            "https://hyprcom-public.s3.ap-south-1.amazonaws.com",
            "https://imageserver.xenie.in"
        );

        try {
            const callBody = {
                keyData: keys,
                pic: convertedUrl,
            };

            await apiV1.post('media/create', callBody);
        } catch (err) {
            console.log(err);
        }
    }
    catch (err) {
        console.log(err);
    }
}

function SelectMedia() {
    const dispatch = useDispatch();

    const { media } = useSelector((state) => state.storefront.media);

    async function handleUploadMedia(e) {
        const image = e.target.files[0];

        try {
            if(image.size > 1048576) {
                try {
                    let compressedBlob = await imageCompression(image, {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                    });

                    let compressedFile = new File([compressedBlob], image.name, { type: image.type, lastModified: Date.now() });

                    if (compressedFile) {
                        await uploadMedia(compressedFile);
                    }
                    else {
                        await uploadMedia(image);
                    }
                }
                catch(err) {
                    await uploadMedia(image);
                }
            }
            else {
                await uploadMedia(image);
            }
            dispatch(fetchMedia());
        }
        catch(err) {
            console.log(err);
        }

        e.target.value = null;
    }

    function handleCloseModal() {
        dispatch(closeModal());
    }

    return (
        <div className='z-20 w-4/5 h-[90%] rounded-[20px] px-8 py-4 bg-[#FFFFFF] shadow-[0_0_12px_0_#0000003D] flex flex-col'>
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Media</h1>

                <button onClick={handleCloseModal} className="outline-none size-11 flex items-center justify-center">
                    <img src={Close} alt="" />
                </button>
            </div>

            <input 
                onChange={handleUploadMedia} 
                className='hidden' 
                type="file" 
                accept="image/*" 
                name="media" 
                id="media" 
            />

            <div className="w-full max-h-[calc(100%-44px)] flex flex-col gap-1 overflow-y-scroll no-scrollbar">
                <div className="flex items-center justify-between text-[16px] leading-5">
                    <p className='font-medium'>Stored files &#40;{media.length}&#41;</p>

                    <div className="py-3">
                        <label htmlFor='media' className='font-semibold text-[#1055EB] underline cursor-pointer'>Upload from computer</label>
                    </div>
                </div>

                <div className="grid grid-cols-4 gap-x-1 gap-y-1">
                    {media.map(item => {
                        return (
                            <ImageBox 
                                key={item.id} 
                                media={item} 
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    );
}

export default SelectMedia;
